import React from "react";
import { Box, Skeleton, Stack, Grid, Container } from "@mui/material";
import { detectDeviceEnvironment } from "../../general/util";

const LoaderPlaceholder = () => {
	return (
		<Stack spacing={2} sx={{ p: 4 }}>
			{/* HEADER */}
			<Grid
				container
				justifyContent="space-between"
				alignItems="center"
				sx={{ mb: 2 }}
			>
				<Grid item>
					<Skeleton variant="rectangular" width={140} height={40} />
				</Grid>
			</Grid>
			
			<Container
				style={{margin: 'auto'}}
				sx={{
					mb: 6,
					mt:
						detectDeviceEnvironment().isInStandaloneMode ||
						detectDeviceEnvironment().isWebView
							? 12
							: 8,
					p: 1,
				}}
				maxWidth="md"
			>
				<Box
					component="placeholder"
					sx={{ flexGrow: 1, position: "relative" }}
				>
					{/* HERO IMAGE / CAROUSEL */}
					<Skeleton
						variant="rectangular"
						width="100%"
						height={250}
						sx={{ mt: 4, mb: 3, borderRadius: 2 }}
					/>
					
					{/* MENU BUTTONS */}
					<Stack spacing={2} mt={2}>
						{Array.from({ length: 5 }).map((_, idx) => (
							<Skeleton
								key={idx}
								variant="rectangular"
								width="100%"
								height={56}
								sx={{ borderRadius: 1, mb: 1 }}
							/>
						))}
					</Stack>
				</Box>
			</Container>
			
			{/* FOOTER NAVIGATION */}
			<Box
				sx={{
					position: "fixed",
					bottom: 0,
					left: 0,
					right: 0,
					p: 2,
					bgcolor: "background.paper",
					borderTop: "1px solid #e0e0e0",
					display: "flex",
					justifyContent: "space-around",
					gap: 2, // spacing between icons
				}}
			>
				{Array.from({ length: 3 }).map((_, idx) => (
					<Skeleton
						key={idx}
						variant="circular"
						width={50}
						height={50}
					/>
				))}
			</Box>
		</Stack>
	);
};

export default LoaderPlaceholder;
